export default "__VITE_ASSET__BkqI4WFZ__"